
import request from '../../utils/request'
import server from './config'
export default {
  getPointsDetail:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/points/patientPointsSum/${data.patientMemberId}`,
      method: 'post',
      data
    })
  },
  getPointsLogList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/points/getPageList`,
      method: 'post',
      data,
      noToast:true,
    })
  },
  //任务列表
  patientTaskList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientTask/getPageList`,
      method: 'post',
      data
    })
  },
  //任务详情
  patientTaskDetail:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientTask/${params.id}`,
      method: 'get',
      params
    })
  },
  getPatientPointsList:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/points/${params.id}`,
      method: 'get',
      params
    })
  },
  //积分进度
  getPatientPointsSchedule:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/points/schedule/${params.id}`,
      method: 'get',
      params
    })
  },
  //活动详情
  getActivityDetail:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/activity/${params.id}`,
      method: 'get',
      params
    })
  },
  // 文章详情
  getArticleDetail:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientTask/articleDetail/${data.id}`,
      method: 'post',
      data
    })
  },
  completeTask:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientTask/completeTask/${params.id}`,
      method: 'get',
      params
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/points.js